import React, { Component } from 'react';
import { PlanBox, BtnFooter, FreePlanModule } from './components';
import Dataplan from './dataplan.json';

class PricingPlans extends Component {
  componentDidMount() {}

  render() {
    return (
      <div className="pricing-plans">
        <div id="pricing" className="fixed-plans">
          <div className="banner">
            <noscript>
              <img
                height="1"
                width="1"
                alt=""
                src="https://analytics.twitter.com/i/adsct?txn_id=l4ru9&p_id=Twitter"
              />
              <img height="1" width="1" alt="" src="//t.co/i/adsct?txn_id=l4ru9&p_id=Twitter" />
            </noscript>
            <div className="container">
              {this.props.headingImage &&
                <img
                  className="section-heading-image"
                  src={this.props.headingImage}
                  alt="features"
                />}
              <h1>Flexible pricing, for developers and <br /> companies</h1>
            </div>
            <FreePlanModule />
            <section className="pricing-module" data-pricing-category="developers">
              <div className="container">
                <PlanBox data={Dataplan} />
                <BtnFooter />
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default PricingPlans;



// WEBPACK FOOTER //
// ./src/components/pricingPlans/PricingPlans.js